import { Component } from 'react';
import { withRouter } from 'react-router-dom';

const event = new Event('lbx:page:load');
const DEBUG = false;

export const ROUTE_CHANGE_LISTENER = 'ROUTE_CHANGE_LISTENER';

class RouteChangeListener extends Component {
    componentDidUpdate(prevProps) {
        const { location } = this.props;
        const { location: prevLocation } = prevProps;

        if (location !== prevLocation) {
            this.handleLocationChange();
        }
    }

    handleLocationChange = () => {

        if (DEBUG) {
           console.log('%cRouteChangeListener: Route changed', 'background: red; color: white; border-radius: 5px; padding: 2px 5px;');
        }

        document.dispatchEvent(event);
    };

    render() {
        return null;
    }
}

export default withRouter(RouteChangeListener);
